/* unplugin-vue-components disabled */import { render } from "./NoResult.vue?vue&type=template&id=c1e0aa6c"
import script from "./NoResult.vue?vue&type=script&lang=js"
export * from "./NoResult.vue?vue&type=script&lang=js"

import exportComponent from "/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__